import * as React from "react";

import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import IconSvgBreadCrumb from "@tunnel-components/@sharded/@widgets/svg/component";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";
import Notifications from "@tunnel-components/@sharded/notifications";
import * as Utils from "@Cyclope-Utils/index";
import * as jwt_decode from "jwt-decode";
import * as i18next from "i18next"; // traduction
import * as Enums from "@tunnel-enums/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  const {
    /*notifications ,*/ onCloseTools,
    onCloseAdmin,
    // onNotification,
    onOpenModal,
    onCloseNotification,
    // openNotif,
    onLogout,
    open,
    onOpen,
    openAdmin,
    onOpenAdmin,
  } = props;

  /**
   * @description : Retourne un objet de type any { utilisateur }
   * @const
   * @name data
   * @type { any }
   */
  const data: any =
    Utils.localStorageIsKeyExist() &&
    jwt_decode(Utils.localStorageIsKeyExist());

  /** Attribué un rôle à l'utilisateur */
  const User = Utils.createdUserRoles();

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name jwt-decode
   * @infos "https://reactjs.org"
   */

  return (
    <div className="top-header">
      <div className="header">
        <div className="headerLeft left">
          <div className="logoName" />
        </div>
        <div className="headerRight left">
          <div className="HeaderRightContent">
            <span className="HeaderSpanAuto">
              <div className="Containerheader" onMouseLeave={onCloseAdmin}>
                <div className="headerInfostitle" onClick={onOpenAdmin}>
                  <p>{data && data.sub}</p>
                  <Styled.Icon style={{ width: "13px", right: "10px" }}>
                    <StyledIcon user={true} color="white" />
                  </Styled.Icon>
                </div>
                <Styled.BreadBoxContainer
                  isVisible={openAdmin}
                  style={{ right: "0", color: "black", minWidth: "170px" }}
                >
                  <div className="actionText" onClick={onLogout}>
                    <div className="actionIcon left">
                      <IconSvgBreadCrumb
                        width="17"
                        height="17"
                        user={true}
                        color="#007ADF"
                      />
                    </div>
                    <p className="actionTitle left">
                      {i18next.t("deconnexion")}
                    </p>
                  </div>
                  {Utils.simpleAuthorizationIsAllowed(User, [
                    Enums.AuthorizationRightsEnums.CHANGEPASSWORD,
                  ]) && (
                    <div className="actionText" onClick={onOpenModal}>
                      <div className="actionIcon left">
                        <IconSvgBreadCrumb
                          width="17"
                          height="17"
                          administration={true}
                        />
                      </div>
                      <p className="actionTitle left">
                        {i18next.t("mot de passe")}
                      </p>
                    </div>
                  )}
                </Styled.BreadBoxContainer>
              </div>

              {Utils.simpleAuthorizationIsAllowed(User, [
                Enums.AuthorizationRightsEnums.TOOLSACCESS,
              ]) &&
                (Utils.simpleAuthorizationIsAllowed(User, [
                  Enums.AuthorizationRightsEnums.EXTRACTEDTHALESSEQUENCE,
                ]) ||
                  Utils.simpleAuthorizationIsAllowed(User, [
                    Enums.AuthorizationRightsEnums.CITILOGLISTS,
                  ])) && (
                  <div className="Containerheader" onMouseLeave={onCloseTools}>
                    <div className="headerInfostitle" onClick={onOpen}>
                      <p>{i18next.t("outils")}</p>
                      <Styled.IconRotate
                        rotates={!open}
                        style={{ width: "13px", right: "10px" }}
                      >
                        <StyledIcon arrowWite={true} />
                      </Styled.IconRotate>
                    </div>
                    <Styled.BreadBoxContainer
                      isVisible={open}
                      style={{ right: "0", color: "black", minWidth: "170px" }}
                    >
                      {Utils.simpleAuthorizationIsAllowed(User, [
                        Enums.AuthorizationRightsEnums.EXTRACTEDTHALESSEQUENCE,
                      ]) && (
                        <div className="actionText">
                          <Link to={Paths.PathsNamesEnums.EXTRACTOR}>
                            <div className="actionIcon left">
                              <IconSvgBreadCrumb
                                width="17"
                                height="17"
                                exportCamera={true}
                              />
                            </div>
                            <p className="actionTitle left">
                              {i18next.t("extraction video")}
                            </p>
                          </Link>
                        </div>
                      )}
                      {Utils.simpleAuthorizationIsAllowed(User, [
                        Enums.AuthorizationRightsEnums.CITILOGLISTS,
                      ]) && (
                        <div className="actionText" onClick={onOpenModal}>
                          <Link to={Paths.PathsNamesEnums.CITILOGINCIDENT}>
                            <div className="actionIcon left">
                              <IconSvgBreadCrumb
                                width="17"
                                height="17"
                                explorer={true}
                              />
                            </div>
                            <p className="actionTitle left">
                              {i18next.t("citilog")}
                            </p>
                          </Link>
                        </div>
                      )}
                    </Styled.BreadBoxContainer>
                  </div>
                )}
              {true && (
                <div
                  className="Containerheader"
                  style={{ border: "none", maxWidth: "40px", marginLeft: "0", position: "relative" }}
                  onMouseLeave={onCloseNotification}
                >
                  <Notifications polling_delay={1} popup_hiding_delay={7} />
                </div>
              )}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

Component.defaultProps = {
  open: false,
  openAdmin: false,
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  notifications?: any;
  onOpenAdmin?: any;
  openAdmin?: any;
  onOpen?: any;
  open?: boolean;
  onLogout?: any;
  onOpenModal?: any;
  onCloseTools?: any;
  onCloseAdmin?: any;
  openNotif?: boolean;
  onNotification?: any;
  onCloseNotification?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/header/component.tsx